import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { ThunkDispatch } from "@reduxjs/toolkit";
import { LoadingSpinner } from './../../../components/Icons'
import CustomIconButton from "../../../components/CustomIconButton";
import CustomButton from "../../../components/CustomButton";
import Dropdown from "../../../components/Dropdown";
import { createStatus } from "../../../reducers/talentMypage";

interface InterestedJobProps {
    onClose: () => void;
}

const InterestedJob: React.FC<InterestedJobProps> = ({ onClose }) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const talentMypage = useSelector((state: any) => state.talentMypage)
    const { isLoading, professionOptions } = useSelector((state: any) => state.talentMypage)
    const [isEditing, setIsEditing] = useState(false)
    const [selectedProfession, setSelectedProfession] = useState<any>(null);
    const [selectedProfession2, setSelectedProfession2] = useState<any>(null);
    const [selectedProfession3, setSelectedProfession3] = useState<any>(null);
    const [profession1Options, setProfession1Options] = useState([]);
    const [profession2Options, setProfession2Options] = useState([]);
    const [profession3Options, setProfession3Options] = useState([]);
    const profession2DropdownRef = useRef<HTMLDivElement>(null)
    const profession3DropdownRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if(talentMypage?.talent && professionOptions) {
            const profession1 = professionOptions.find((item:any) => item?.id === talentMypage?.talent?.profession_1_id);
            const profession2 = professionOptions.find((item:any) => item?.id === talentMypage?.talent?.profession_2_id);
            const profession3 = professionOptions.find((item:any) => item?.id === talentMypage?.talent?.profession_3_id);
            setSelectedProfession(profession1 || null);
            setSelectedProfession2(profession2 || null);
            setSelectedProfession3(profession3 || null);

            setProfession1Options(professionOptions.filter(item => item.level == 1))

            if(talentMypage?.talent?.profession_1_id) {
                setProfession2Options(professionOptions.filter(item => item.parent_id == profession1.code && item.level == 2))
            }
            if(talentMypage?.talent?.profession_2_id) {
                setProfession3Options(professionOptions.filter(item => item.parent_id == profession2.code && item.level == 3))
            }
        }
    }, [talentMypage, professionOptions])

    const saveChangeProfession = () => {
        if(selectedProfession?.id == talentMypage?.talent?.profession_1_id &&
           selectedProfession2?.id == talentMypage?.talent?.profession_2_id &&
           selectedProfession3?.id == talentMypage?.talent?.profession_3_id) {
            return
        }
        dispatch(createStatus({
            requestBody: { 
                change_job_status_id: talentMypage?.talent?.change_job_status?.id || null, 
                work_parttime_status_id: talentMypage?.talent?.work_part_time_status?.id || null, 
                profession_1_id: selectedProfession?.id || null,
                profession_2_id: selectedProfession2?.id || null,
                profession_3_id: selectedProfession3?.id || null,
                industry_1_id: talentMypage?.talent?.industry_1_id || null,
                industry_2_id: talentMypage?.talent?.industry_2_id || null,
                industry_3_id: talentMypage?.talent?.industry_3_id || null,
                working_style_1_id: talentMypage.talent?.working_style_1_id || null,
                working_style_2_id: talentMypage.talent?.working_style_2_id || null,
                working_style_3_id: talentMypage.talent?.working_style_3_id || null,
                preferred_city_1_id: talentMypage?.talent?.preferred_city_1_id || null,
                preferred_city_2_id: talentMypage?.talent?.preferred_city_2_id || null,
                preferred_city_3_id: talentMypage?.talent?.preferred_city_3_id || null
            },
          }),
        );
        setIsEditing(false)
        onClose();
    };

    const handleChangeProfessionLevel1 = (value) => {
        setSelectedProfession(value);
        setSelectedProfession2(null);
        setSelectedProfession3(null);
        setIsEditing(true)

        // Reload options level 2
        if (value && value.code) {
            setProfession2Options(professionOptions.filter(item => item.parent_id == value.code && item.level == 2))
        } else {
            setProfession2Options([])
        }

        // Reload options level 3
        setProfession3Options([])

        // Forcus to 職種２
        profession2DropdownRef.current?.focus();
    }

    const handleChangeProfessionLevel2 = (value) => {
        setSelectedProfession2(value);
        setSelectedProfession3(null);
        setIsEditing(true)

        // Reload options level 2
        if (value && value.code) {
            setProfession3Options(professionOptions.filter(item => item.parent_id == value.code && item.level == 3))
        } else {
            setProfession3Options([])
        }

        // Forcus to 職種２
        profession3DropdownRef.current?.focus();
    }

    return (
        <div className="w-[392px] max-w-full h-full bg-white rounded-2xl pt-3 alu-panel-box-shadow">
            <div className="flex items-center justify-between gap-2 px-4 mb-1">
                <h2 className="text-xl leading-[1.875rem] font-bold alu-text-base-2">経験した職種</h2>
                <CustomIconButton onClick={onClose} customStyle="shrink-0">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_8574_265)">
                        <path
                            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                            fill="currentColor"
                        />
                        </g>
                        <defs>
                        <clipPath id="clip0_8574_265">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                        </defs>
                    </svg>
                </CustomIconButton>
            </div>
            <div className="overflow-y-auto custom-scrollbar h-[calc(100%-40px)] px-4 pb-4">
                <form className="mt-6 w-full flex flex-col">

                    {/* {isEditing && ( */}
                    <label className="alu-text-base-2 text-sm font-bold mb-2">職種１</label>
                    <Dropdown
                        options={profession1Options}
                        value={selectedProfession}
                        onChange={(value: any) => handleChangeProfessionLevel1(value)}
                        placeholder="選択してください"
                        inputWidth="full"
                        customStyle="mb-4"
                        optionsFixedWidth={true}
                    />
                    <label className="alu-text-base-2 text-sm font-bold mb-2">職種２</label>
                    <Dropdown
                        dropdownRef={profession2DropdownRef}
                        options={profession2Options}
                        value={selectedProfession2}
                        onChange={(value: any) => handleChangeProfessionLevel2(value)}
                        placeholder="選択してください"
                        inputWidth="full"
                        customStyle="mb-4"
                        optionsFixedWidth={true}
                        disabled={!selectedProfession}
                    />
                    <label className="alu-text-base-2 text-sm font-bold mb-2">職種３</label>
                    <Dropdown
                        dropdownRef={profession3DropdownRef}
                        options={profession3Options}
                        value={selectedProfession3}
                        onChange={(value: any) => {setSelectedProfession3(value); setIsEditing(true)}}
                        placeholder="選択してください"
                        inputWidth="full"
                        customStyle="mb-10"
                        optionsFixedWidth={true}
                        disabled={!selectedProfession2}
                    />
                    
                    <div className="flex items-center justify-between gap-4">
                        <CustomButton
                            type="button"
                            onClick={() => onClose()}
                            width="full"
                            variant="outline"
                            size="md"
                        >
                            キャンセル
                        </CustomButton>
                        <CustomButton
                            type="button"
                            onClick={() => saveChangeProfession()}
                            disabled={isLoading || !isEditing || !selectedProfession?.id || !selectedProfession2?.id || !selectedProfession3?.id}
                            width="full"
                            size="md"
                        >
                            <p>{isLoading ? "保存中..." : "保存"}</p>
                            {isLoading && (
                                <span><LoadingSpinner /></span>
                            )}
                        </CustomButton>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default InterestedJob;